// Schlüssel `bl.theme` wie in public/theme.js. Hell ist die Vorgabe (DECISIONS E15).
type Thema = "light" | "dark";

export function thema(): Thema {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function schalteThema(): Thema {
  const neu: Thema = thema() === "dark" ? "light" : "dark";
  document.documentElement.classList.toggle("dark", neu === "dark");
  document.documentElement.classList.toggle("light", neu === "light");
  try {
    localStorage.setItem("bl.theme", JSON.stringify(neu));
  } catch {
    /* privates Fenster: dann gilt es eben nur bis zum Neuladen */
  }
  return neu;
}
